import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=1278f1c6"
import script from "./Projects.vue?vue&type=script&lang=ts"
export * from "./Projects.vue?vue&type=script&lang=ts"
import style0 from "./Projects.vue?vue&type=style&index=0&id=1278f1c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports